export default function getDateDomain(dates: Array<string | Date>): [Date, Date] {
  const times = dates.map((date) => new Date(date).getTime());
  return [new Date(Math.min(...times)), new Date(Math.max(...times))];
}
